import { NavLink, useLocation } from "react-router-dom";
import { BookOpen, Map } from "lucide-react";

const DESIGN_ROUTES = ["/design", "/floorplans"];

/**
 * Secondary tab row shown above the bottom nav when the user is in
 * the Design or Floorplans section. Mobile-only — desktop has the
 * sidebar sub-items instead.
 */
export default function DesignTabBar() {
  const { pathname } = useLocation();
  if (!DESIGN_ROUTES.includes(pathname)) return null;

  return (
    <div
      className="md:hidden fixed left-0 right-0 z-[39] flex items-center justify-center gap-2 px-4 py-2"
      style={{
        bottom: "var(--bottom-nav-h, 64px)",
        height: "var(--secondary-nav-h, 44px)",
        background: "color-mix(in srgb, var(--bg-root) 95%, transparent)",
        borderTop: "1px solid var(--border-card-base)",
        backdropFilter: "blur(8px)",
      }}
    >
      {[
        { to: "/design", icon: BookOpen, label: "Design Book" },
        { to: "/floorplans", icon: Map, label: "Floorplans" },
      ].map(({ to, icon: Icon, label }) => (
        <NavLink
          key={to}
          to={to}
          end
          className="flex items-center gap-1.5 px-4 py-1.5 rounded-full text-xs font-semibold transition-colors"
          style={({ isActive }) =>
            isActive
              ? { background: "var(--accent-bg)", color: "var(--accent-text)" }
              : { background: "var(--bg-input)", color: "var(--text-secondary)", border: "1px solid var(--border-input)" }
          }
        >
          <Icon className="w-3.5 h-3.5" />
          {label}
        </NavLink>
      ))}
    </div>
  );
}
